export const TEXT = {
  NO_SITES_TITLE: "Failed to fetch Site hierarchy",
  NO_SITES_DESC: "Sites are not created for this account.",
  UNNAMED_FLOOR: "Unnamed Floor"
};
